export default __webpack_public_path__ + "static/media/mailing.52579ce6.svg";